import React, { useMemo } from 'react';
import { Select, Form } from 'antd';
import { useTranslation } from 'react-i18next';
import dayjs from 'dayjs';
import { required } from '../FormValidation';

/**
 * FormAcademicYear - Komponent pre výber akademického roku
 *
 * Akademický rok má formát "YYYY/YYYY+1" kde:
 * - Ak je aktuálny mesiac september alebo neskorší, akademický rok začína aktuálny rok
 * - Ak je aktuálny mesiac august alebo skorší, akademický rok začína predchádzajúci rok
 *
 * @param {string} label - Označenie poľa
 * @param {string} name - Názov poľa vo formulári
 * @param {Array} rules - Pravidlá validácie
 * @param {boolean} disabled - Či je pole zakázané
 * @param {Object} ...rest - Ďalšie props pre Select komponent
 */
const FormAcademicYear = ({ label, name, rules, disabled, ...rest }) => {
  const { t } = useTranslation();
  // Výpočet aktuálneho akademického roku
  const getCurrentAcademicYear = () => {
    const now = dayjs();
    const currentYear = now.year();
    const currentMonth = now.month(); // 0 = január, 8 = september

    // Ak je september alebo neskorší, akademický rok začína tento rok
    // Inak začína minulý rok
    const startYear = currentMonth >= 8 ? currentYear : currentYear - 1;
    return `${startYear}/${startYear + 1}`;
  };

  // Generovanie možností akademických rokov
  const academicYearOptions = useMemo(() => {
    const currentYear = dayjs().year();
    const options = [];

    // Generujeme roky od (aktuálny - 5) do (aktuálny + 5)
    for (let i = currentYear - 5; i <= currentYear + 5; i++) {
      const academicYear = `${i}/${i + 1}`;
      options.push({
        key: academicYear, // Pridávame unikátny key
        value: academicYear,
        label: academicYear,
      });
    }

    return options;
  }, []);

  return (
    <Form.Item label={label} name={name} rules={rules}>
      <Select
        placeholder={t('Vyberte akademický rok')}
        disabled={disabled}
        style={{ width: '100%' }}
        options={academicYearOptions}
        showSearch
        filterOption={(input, option) =>
          (option?.label ?? '').toLowerCase().includes(input.toLowerCase())
        }
        {...rest}
      />
    </Form.Item>
  );
};

export default FormAcademicYear;
